import { render, staticRenderFns } from "./FabricAccessoryShow.vue?vue&type=template&id=29b6ad37&scoped=true"
import script from "./FabricAccessoryShow.vue?vue&type=script&lang=js"
export * from "./FabricAccessoryShow.vue?vue&type=script&lang=js"
import style0 from "./FabricAccessoryShow.vue?vue&type=style&index=0&id=29b6ad37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b6ad37",
  null
  
)

export default component.exports